export function staffTitles(gender) {
  if (gender === "female") return { counselor: "المرشدة الطلابية", principal: "مديرة المدرسة", leader: "قائدة المدرسة", deputy: "وكيلة شؤون الطلاب" };
  if (gender === "male") return { counselor: "المرشد الطلابي", principal: "مدير المدرسة", leader: "قائد المدرسة", deputy: "وكيل شؤون الطلاب" };
  return { counselor: "المرشد/المرشدة الطلابي/ة", principal: "مدير/مديرة المدرسة", leader: "قائد/قائدة المدرسة", deputy: "وكيل/وكيلة شؤون الطلاب" };
}
